export const API_BASE_URL = "https://your-api-url.com/";

export const PREFIX = "/en/api/v1.0";
export const UPLOAD_FILE = `${PREFIX}/Media/upload`;
export const DELETE_FILE = "/api/fileid";

export const GET_PROFILE = `${PREFIX}/User/profile`;
export const ACCOUNT_LOGIN = `${PREFIX}/User/login`;
export const VERIFY_LOGIN_OTP = `${PREFIX}/User/login/verify-otp`;
export const SEND_LOGIN_OTP = `${PREFIX}/User/login/send-otp`;
export const SIGN_OUT = `${PREFIX}/User/logout`;
export const FORGOT_PASSWORD = `${PREFIX}/User/password/forgot-by-email`;
export const RESET_PASSWORD = `${PREFIX}/User/password/reset-by-email`;
export const CHANGE_PASSWORD = `${PREFIX}/User/password/change`;
export const SET_EMPLOYEE_PASSWORD = `${PREFIX}/User/password/set-for-employee`;
export const SET_EMPLOYEE_OTP = `${PREFIX}/User/otp/set-for-employee`;
export const SEARCH_BY_ROLES = `${PREFIX}/User/search-by-roles`;
export const REFRESH_TOKEN_API = `${PREFIX}/TokenManager/refresh-token`;

const RATING_API = `${PREFIX}/Rating`;
export const RATING_GETBYCODE_API = `${RATING_API}/get-by-code`;
export const RATING_SUBMIT_API = `${RATING_API}/submit`;
export const ESIGN_CHECKTHE_API = `${PREFIX}/Esign/check-the`;
export const ESIGN_SUBMIT_API = `${PREFIX}/Esign/submit`;

const REPORT_API = `${PREFIX}/Report`;
export const REPORT_FEEDBACK_FROM_CUSTOMER_API = `${REPORT_API}/feedback-from-customer`;
export const REPORT_CHART_HOSPITAL_API = `${REPORT_API}/chart-hospital`;
export const REPORT_CHART_ALL_HOSPITAL_API = `${REPORT_API}/chart-all-hospital`;
export const REPORT_CHART_KCB_ALL_HOSPITAL_API = `${REPORT_API}/chart-kcb-all-hospital`;
export const REPORT_CHART_KCB_HOSPITAL_API = `${REPORT_API}/chart-kcb-hospital`;

const CDHA_API = `${PREFIX}/KetQuaCdha`;
export const CDHA_VIEW_API = `${CDHA_API}/cdha`;
const XETNGHIEM_API = `${PREFIX}/KetQuaXetNghiem`;
export const XETNGHIEM_VIEW_API = `${XETNGHIEM_API}/xetnghiem`;

export const DEPARTMENT_API = `${PREFIX}/Department`;
export const DEPARTMENT_SEARCH_GRID_API = `${DEPARTMENT_API}/search-grid`;
export const DEPARTMENT_HOSPITALS_API = `${DEPARTMENT_API}/hospitals`;
export const DEPARTMENT_BRANCH_API = `${DEPARTMENT_API}/branches`;
export const CATEGORY_API = `${PREFIX}/Category`;
export const GET_BY_JOB_POSITION_API = `${CATEGORY_API}/get-by-job-position`;
export const GET_BY_JOB_SPECCIALIZE_API = `${CATEGORY_API}/get-by-job-Specialize`;
export const GET_BY_JOB_TITLE_API = `${CATEGORY_API}/get-by-job-title`;
export const GET_BY_DEPARTMENT_API = `${CATEGORY_API}/get-by-department`;
export const GET_BY_WORK_STATUS_API = `${CATEGORY_API}/get-by-work-status`;
export const GET_BY_HIS_DEPARTMENT_API = `${CATEGORY_API}/get-by-his-department`;
export const GET_BY_DEPARTMENT_LEVEL_API = `${CATEGORY_API}/get-by-department-level`;
export const GET_BY_AUTH_PERMIT = `${CATEGORY_API}/get-by-auth-permit`;
export const GET_DEAPARTMENT_BY_BRANCH = `${CATEGORY_API}/department-by-branch`;
export const GET_SPECALIZE_BY_BRANCH = `${CATEGORY_API}/speciality`;
export const GET_PROVINCE_API = `${CATEGORY_API}/location/province`;
export const GET_DISTRICT_BY_PROVINCE_API = `${CATEGORY_API}/location/district-by-province`;
export const GET_WARD_BY_DISTRICT_API = `${CATEGORY_API}/location/ward-by-district`;
export const GET_TIME_SLOT = `${CATEGORY_API}/timeslot`;
export const GET_ALL_HOSPITAL_API = `${CATEGORY_API}/hospital`;
export const GET_ALL_BAGET_API = `${CATEGORY_API}/baget`;
export const GET_KHAMLAI_BAGET_API = `${CATEGORY_API}/baget-khamlai`;
export const GET_ALL_NATION_API = `${CATEGORY_API}/nation`;
export const GET_LOAI_CA_LAM_VIEC_CATEGORY_API = `${CATEGORY_API}/loai-ca`;
export const GET_SYMBOL_CATEGORY_API = `${CATEGORY_API}/symbol`;
export const GET_Reason_CATEGORY_API = `${CATEGORY_API}/reason`;
export const GET_ALL_EMPLOYEE_API = `${CATEGORY_API}/get-by-employee`;
export const GET_ALL_THIETLAPLYDO_API = `${CATEGORY_API}/get-by-thiet-lap-ly-do-xac-nhan`;
export const GET_ALL_DMPHAMVICHUYENMON_API = `${CATEGORY_API}/get-dm-phamvichuyenmon`;
export const GET_ALL_DANH_MUC_CAP_BAC_API = `${CATEGORY_API}/cap-bac`;
export const GET_ALL_DANH_MUC_NGAN_HANG_API = `${CATEGORY_API}/ngan-hang`;
export const GET_ALL_DANH_MUC_MAY_CHAM_CONG_API = `${CATEGORY_API}/may-cham-cong`;

export const EMPLOYEE_API = `${PREFIX}/Employee`;
export const EMPLOYEE_GRID_API = `${EMPLOYEE_API}/search-grid`;
export const EMPLOYEE_SEARCH_EMPLOYEE_API = `${EMPLOYEE_API}/search-employees`;
export const DETAIL_API = `${EMPLOYEE_API}/detail`;
export const CHANGE_STATE_EMPLOYEE_API = `${EMPLOYEE_API}/change-state`;
export const EXPORT_EXCEL_EMPLOYEE_API = `${EMPLOYEE_API}/export-excel`;
export const IMPORT_EXCEL_EMPLOYEE_API = `${EMPLOYEE_API}/import-excel`;
export const IMPORT_DSNV_EMPLOYEE_API = `${EMPLOYEE_API}/import-dsnv`;
export const IMPORT_HISTORY_API = `${EMPLOYEE_API}/import-history`;
export const IMPORT_EMPLOYEE_APPLIER_API = `${EMPLOYEE_API}/import-dsnv-applier`;

const USER_PERMISSION_API = `${PREFIX}/UserPermission`;
export const USER_BRANCH_API = `${USER_PERMISSION_API}/user-branchs`;
export const USER_SCOPE_API = `${USER_PERMISSION_API}/user-scopes`;
export const USER_ROLE_API = `${USER_PERMISSION_API}/user-roles`;

const ROLE_PERMIT_API = `${PREFIX}/RolePermission`;
export const ROLE_BY_SCOPE_API = `${ROLE_PERMIT_API}/role-by-scope`;
export const ROLE_DETAIL_API = `${ROLE_PERMIT_API}/role-detail`;
export const ADD_ROLE_API = `${ROLE_PERMIT_API}/add-role`;
export const UPDATE_ROLE_API = `${ROLE_PERMIT_API}/update-role`;
export const DELETE_ROLE_API = `${ROLE_PERMIT_API}/delete-role`;
export const UPDATE_ROLE_PERMIT_API = `${ROLE_PERMIT_API}/update-role-permit`;
export const ROLE_BY_PERMIT = `${ROLE_PERMIT_API}/role-by-permit`;
export const FAVORITE_MENU_API = `${PREFIX}/FavoriteMenu`;

const SETTING_API = `${PREFIX}/Setting`;
export const SEARCH_BANNER_API = `${SETTING_API}/banner/search-grid`;
export const BANNER_API = `${SETTING_API}/banner`;
export const SETTING = `${SETTING_API}`;
export const DANH_GIA_API = `${PREFIX}/DanhGiaCLDV`;

export const POSTS_API = `${PREFIX}/Blog`;
export const SEARCH_POSTS_API = `${POSTS_API}/search-grid`;

export const KHACH_HANG_API = `${PREFIX}/KhachHang`;
export const HOSPITAL_MANAGER_API = `${PREFIX}/HospitalManagement`;
export const DOCTOR_MANAGEMENT_API = `${PREFIX}/DoctorManagement`;
export const APPOINTMENT_API = `${PREFIX}/Appointment`;
export const TONGHOP_DAT_LICH_API = `${PREFIX}/TongHopDatLich`;
export const NOTIFICATION_API = `${PREFIX}/Notification`;
export const AMBULANCE_API = `${PREFIX}/Ambulance`;
export const DICHVUTAINHACATEGORY_API = `${PREFIX}/DichVuTaiNhaCategory`;
export const DICHVUTAINHA_API = `${PREFIX}/DichVuTaiNha`;
export const MARKETING_CAMPAIGN_API = `${PREFIX}/MarketingCampaign`;
export const MARKETING_SETTING_API = `${PREFIX}/ThietLapDmMKT/thiet-lap-dm-mkt`

export const COMMENT_API = `${PREFIX}/Comment`;
export const SEARCH_COMMENT_API = `${COMMENT_API}/search-grid`;
// export
export const CRM_EXPORT_API = `${PREFIX}/ExportTransaction`;

// BHXH Category
const BHYT_CATEGORY_API = `${PREFIX}/BhytCategory`;
export const BHYT_SEARCH_DSNV = `${BHYT_CATEGORY_API}/search-dsnv`;
export const BHYT_IMPORT_DSNV = `${BHYT_CATEGORY_API}/import-dsnv`;
export const BHYT_APPLY_DSNV = `${BHYT_CATEGORY_API}/apply-dsnv`;

export const HRRECORD_API = `${PREFIX}/HRRecord`;
export const HRRECORD_ALL_API = `${HRRECORD_API}/hs-all-level`;

export const HRRECORD_HSC1_API = `${HRRECORD_API}/hsc1`;
export const CHANGE_STATE_HSC1_API = `${HRRECORD_API}/hsc1/change-state`;
export const HRRECORD_HSC2_API = `${HRRECORD_API}/hsc2`;
export const CHANGE_STATE_HSC2_API = `${HRRECORD_API}/hsc2/change-state`;
export const EXPORT_HSNV_API = `${HRRECORD_API}/export-hsnv`;
export const EXPORT_DSHSNV_API = `${HRRECORD_API}/export-dshsnv`;

// Nội bộ
export const SANG_KIEN_Y_TUONG = `${PREFIX}/SangKienYTuong`;

//Bang Cong
export const BANGCONG_API = `${PREFIX}/BangCong`;
export const CHI_TIET_BANG_CONG_API = `${BANGCONG_API}/chi-tiet`;
export const THIET_LAP_BANG_CONG_API = `${BANGCONG_API}/thiet-lap`;
export const BANG_CONG_TONG_HOP_API = `${BANGCONG_API}/tong-hop-nam`;

//QUAN LY CONG
export const QUAN_LY_CONG_API = `${PREFIX}/QuanLyCong`;
export const QUAN_LY_CONG_THIET_LAP_API = `${QUAN_LY_CONG_API}/ThietLap`;
export const QUAN_LY_CONG_CHAM_CONG_API = `${QUAN_LY_CONG_API}/BangChamCong`;

//Quan ly nghi
export const QUAN_LY_Nghi_API = `${PREFIX}/QuanLyNghi`;
export const DON_XIN_NGHI_API = `${QUAN_LY_Nghi_API}/DonXinNghi`;
export const NGHI_PHEP_NAM_API = `${QUAN_LY_Nghi_API}/NghiPhepNam`;

// Trinh do hoc van
export const TRINH_DO_HOC_VAN_API = `${PREFIX}/TrinhDoHocVan`;
export const DANH_SACH_TRUONG_TOT_NGHIEP_API = `${TRINH_DO_HOC_VAN_API}/truong-tot-nghiep`;
export const TRINH_DO_HOC_VAN_UPSERT_API = `${TRINH_DO_HOC_VAN_API}/up-sert`;
export const TRINH_DO_HOC_VAN_DELETE_API = `${TRINH_DO_HOC_VAN_API}/delete`;

//Tuyển dụng
export const THIETLAPTUYENDUNG_API = `${PREFIX}/ThietLapTuyenDung`;
export const BOTIEUCHI_API = `${PREFIX}/BoTieuChi`;
export const DEXUATTUYENDUNG_API = `${PREFIX}/DeXuatTuyenDung`;
export const GIOITHIEUUNGVIEN_API = `${PREFIX}/GioiThieuUngVien`;
export const HOSOUNGVIEN_API = `${PREFIX}/HoSoUngVien`;
export const DANHGIAUNGVIEN_API = `${PREFIX}/DanhGiaUngVien`;
export const QUANLYDUAN_API = `${PREFIX}/QuanLyDuAn`;

// Công văn
export const QUAN_LY_VAN_BAN_API = `${PREFIX}/VanBan`;
export const CHI_TIET_CONG_VAN_API = `${QUAN_LY_VAN_BAN_API}/get-van-ban`;

//EmploymentContract
export const CONTRACT_API = `${PREFIX}/EmploymentContract`;
export const ECONTRACT_TYPE_SETTING_API = `${CONTRACT_API}/get-contract-typesetting`;
export const ECONTRACT_TYPE_SETTING_UPSERT_API = `${CONTRACT_API}/upsert-contract-typesetting`;
export const ECONTRACT_TYPE_SETTING_DELETE_API = `${CONTRACT_API}/delete-typesetting-byid`;
export const LIST_EMPLOYMENT_CONTRACT_API = `${CONTRACT_API}/contract-list`;
export const UPDATE_EMPLOYMENT_CONTRACT_API = `${CONTRACT_API}/update-contract`;
export const CREATE_EMPLOYMENT_CONTRACT_API = `${CONTRACT_API}/create-contract`;
export const DELETE_EMPLOYMENT_CONTRACT_API = `${CONTRACT_API}/delete-contract`;
export const STOP_EMPLOYMENT_CONTRACT_API = `${CONTRACT_API}/stop-contract`;

export const DETAIL_EMPLOYMENT_CONTRACT_API = `${CONTRACT_API}/chi-tiet`;
export const SYSTEM_EMPLOYMENT_CONTRACT_API = `${CONTRACT_API}/thiet-lap`;
export const SETTING_EMPLOYMENT_CONTRACT_API = `${CONTRACT_API}/contract-setting`;
export const TYPE_EMPLOYMENT_CONTRACT_API = `${CONTRACT_API}/contract-type`;
export const HRM_EMPLOYMENT_CONTRACT_API = `${CONTRACT_API}/contract-hrm`;
export const UPDATE_SETTING_CONTRACT_API = `${CONTRACT_API}/update-contract-setting`;
export const CREATE_TYPE_CONTRACT_API = `${CONTRACT_API}/create-contract-type`;
export const UPDATE_TYPE_CONTRACT_API = `${CONTRACT_API}/update-contract-type`;
export const DELETE_TYPE_CONTRACT_API = `${CONTRACT_API}/delete-contract-type`;

export const GET_CONTRACT_BY_ID_API = `${CONTRACT_API}/get-contract-by-id`;

export const PRACTIVE_MAMAGEMENT_API = `${PREFIX}/PractiveManagement`;
export const NOI_DUNG_THUC_HANH_API = `${PREFIX}/DmNoiDungChuyenMonThucHanh`;
export const XIN_THOI_VIEC_API = `${PREFIX}/XinThoiViec`;
export const THIET_LAP_THUC_HANH_API = `${PREFIX}/ThietLapThucHanh`;

//Training
export const TRAINING_API = `${PREFIX}/Training`;
export const GET_TRAINING_METHODS_API = `${TRAINING_API}/get-training-methods`;
export const UPDATE_TRAINING_METHOD_API = `${TRAINING_API}/update-training-method`;
export const CREATE_TRAINING_METHOD_API = `${TRAINING_API}/create-training-method`;
export const DELETE_TRAINING_METHOD_API = `${TRAINING_API}/delete-training-method`;

export const GET_TRAINING_CENTERS_API = `${TRAINING_API}/get-training-centers`;
export const UPDATE_TRAINING_CENTER_API = `${TRAINING_API}/update-training-center`;
export const CREATE_TRAINING_CENTER_API = `${TRAINING_API}/create-training-center`;
export const DELETE_TRAINING_CENTER_API = `${TRAINING_API}/delete-training-center`;

export const GET_TRAINING_EXPENSES_API = `${TRAINING_API}/get-training-expenses`;
export const UPDATE_TRAINING_EXPENSE_API = `${TRAINING_API}/update-training-expense`;
export const CREATE_TRAINING_EXPENSE_API = `${TRAINING_API}/create-training-expense`;
export const DELETE_TRAINING_EXPENSE_API = `${TRAINING_API}/delete-training-expense`;

export const GET_TRAINING_PROGRAMS_API = `${TRAINING_API}/get-training-programs`;
export const GET_TRAINING_PROGRAM_BY_ID_API = `${TRAINING_API}/get-training-program-by-id`;
export const GET_TRAINING_PROGRAM_ATTENDANCE = `${TRAINING_API}/attendance`;
export const UPDATE_TRAINING_PROGRAM_ATTENDANCE = `${TRAINING_API}/update-attendance`;
export const UPDATE_TRAINING_PROGRAM_API = `${TRAINING_API}/update-training-program`;
export const CREATE_TRAINING_PROGRAM_API = `${TRAINING_API}/create-training-program`;
export const DELETE_TRAINING_PROGRAM_API = `${TRAINING_API}/delete-training-program`;

export const GET_TRAINING_EMPLOYEE_API = `${TRAINING_API}/get-training-employees`;
export const GET_ALL_TRAINING_EMPLOYEE_API = `${TRAINING_API}/get-all-training-employees`;
export const UPDATE_TRAINING_EMPLOYEE_API = `${TRAINING_API}/update-training-employee`;

export const KY_THI__API = `${PREFIX}/KyThi`;
export const DANH_SACH_BAI_THI__API = `${PREFIX}/DanhSachBaiThi`;

//Document File
export const DOCUMENT_FILE_API = `/api/DocumentManage`;
export const GET_DOCUMENT_FILE_TYPES_API = `${DOCUMENT_FILE_API}/getall-document-types`;

//Signature Process
export const SIGNATURE_PROCESS_API = `/api/SignatureProcess`;
export const GET_DOCUMENT_TYPES_API = `${SIGNATURE_PROCESS_API}/getall-document-types`;
export const UPSERT_DOCUMENT_TYPE_ITEM_API = `${SIGNATURE_PROCESS_API}/upsert-document-type-item`;
export const GET_SIGN_POSITIONS_API = `${SIGNATURE_PROCESS_API}/getall-sign-positions`;
export const GET_SIGN_REPORT_API = `${SIGNATURE_PROCESS_API}/get-sign-report`;
export const GET_SIGN_REPORT_DOCUMENT_API = `${SIGNATURE_PROCESS_API}/get-report-document`;
//OVERTIME
export const OVERTIME_API = `${PREFIX}/OverTime`;
export const GET_OVERTIME_API = `${OVERTIME_API}/get-ot`;
export const GET_OVERTIME_BY_ID_API = `${OVERTIME_API}/get-ot-by-id`;
export const UPDATE_OVERTIME_API = `${OVERTIME_API}/update-ot`;
export const CREATE_OVERTIME_API = `${OVERTIME_API}/create-ot`;
export const DELETE_OVERTIME_API = `${OVERTIME_API}/delete-ot`;
//Meal Allowance
export const MEAL_ALLOWANCE_API = `${PREFIX}/MealAllowance`;
export const GET_MEAL_ALLOWANCE_API = `${MEAL_ALLOWANCE_API}/get-ma`;
export const GET_MEAL_ALLOWANCE_BY_ID_API = `${MEAL_ALLOWANCE_API}/get-ma-by-id`;
export const UPDATE_MEAL_ALLOWANCE_API = `${MEAL_ALLOWANCE_API}/update-ma`;
export const CREATE_MEAL_ALLOWANCE_API = `${MEAL_ALLOWANCE_API}/create-ma`;
export const DELETE_MEAL_ALLOWANCE_API = `${MEAL_ALLOWANCE_API}/delete-ma`;
export const CREATE_DANG_KY_CONG_COM_API = `${MEAL_ALLOWANCE_API}/create-cong-com`;
export const GET_DANG_KY_CONG_COM_API = `${MEAL_ALLOWANCE_API}/get-cong-com`;
export const GET_DANG_KY_CONG_COM_BY_ID_API = `${MEAL_ALLOWANCE_API}/get-cong-com-by-id`;
export const FIND_STT_CHOT_CONG_API = `${MEAL_ALLOWANCE_API}/find-status-chot-cong-com-theo-ngay`;
export const CHOT_CONG_COM_API = `${MEAL_ALLOWANCE_API}/chot-cong-com-theo-ngay`;
export const HUY_CONG_COM_BY_HR = `${MEAL_ALLOWANCE_API}/huy-cong-com-by-hr`;
export const NAP_DU_LIEU_COM_THANG_API = `${MEAL_ALLOWANCE_API}/nap-du-lieu-com-thang`;
export const CREATE_MA_DETAIL_API = `${MEAL_ALLOWANCE_API}/create-ma-detail`;
export const GET_MA_DETAIL_API = `${MEAL_ALLOWANCE_API}/get-ma-detail`;
export const UPDATE_MA_DETAIL_API = `${MEAL_ALLOWANCE_API}/update-ma-detail`;
export const DELETE_MA_DETAIL_API = `${MEAL_ALLOWANCE_API}/delete-ma-detail`;
export const UPDATE_MA_TOTAL_EMPLOYEE_API = `${MEAL_ALLOWANCE_API}/update-ma-total-employee`;
// Bang luong
// -- Thiet lap luong
export const QUAN_LY_LUONG_API = `${PREFIX}/QuanLyLuong`;
export const THIETLAP_LUONG_API = `${PREFIX}/ThietLapLuong`;
export const BANG_LUONG_API = `${QUAN_LY_LUONG_API}/BangLuong`;

export const GET_ALL_THIETLAP_LUONG_API = `${THIETLAP_LUONG_API}/danh-sach`;
// Common
export const COMMON_API = `/api/Common`;
// -- Attachment
export const ATTACHMENT_API = `/api/Attachment`;
export const UPLOAD_ATTACHMENT_API = `${ATTACHMENT_API}/upload`;
export const GET_BY_OBJECT_ATTACHMENT_API = `${ATTACHMENT_API}/get-by-object-id`;
// -- Signature Process
export const INTERNAL_API = `${PREFIX}/Internal/update-signature-process`;
// --Notification
export const ERP_NOTIFICATION_API = `/api/ErpNotification`;
export const PRINTER_API = `api/CreatePrint`;

//Quy che- Van ban
export const REGULATION_API = `${PREFIX}/RegulationAndDocument`;
export const GET_REGULATION_SETTING_API = `${REGULATION_API}/get-regulation-setting`;
export const UPDATE_REGULATION_SETTING_API = `${REGULATION_API}/update-regulation-setting`;
export const CREATE_REGULATION_SETTING_API = `${REGULATION_API}/create-regulation-setting`;
export const DELETE_REGULATION_SETTING_API = `${REGULATION_API}/delete-regulation-setting`;

export const GET_DOCUMENT_SETTING_API = `${REGULATION_API}/get-document-setting`;
export const UPDATE_DOCUMENT_SETTING_API = `${REGULATION_API}/update-document-setting`;
export const CREATE_DOCUMENT_SETTING_API = `${REGULATION_API}/create-document-setting`;
export const DELETE_DOCUMENT_SETTING_API = `${REGULATION_API}/delete-document-setting`;
export const DELETE_REGULATION_GROUP_API = `${REGULATION_API}/delete-regulation-group`;

export const GET_REGULATION_MANAGE_API = `${REGULATION_API}/get-regulation-manage`;
export const GET_REGULATION_MANAGE_BY_ID_API = `${REGULATION_API}/get-regulation-manage-by-id`;
export const UPDATE_REGULATION_MANAGE_API = `${REGULATION_API}/update-regulation-manage`;
export const CREATE_REGULATION_MANAGE_API = `${REGULATION_API}/create-regulation-manage`;
export const DELETE_REGULATION_MANAGE_API = `${REGULATION_API}/delete-regulation-manage`;

export const GET_DOCUMENT_MANAGE_API = `${REGULATION_API}/get-document-manage`;
export const GET_DOCUMENT_MANAGE_BY_ID_API = `${REGULATION_API}/get-document-manage-by-id`;
export const UPDATE_DOCUMENT_MANAGE_API = `${REGULATION_API}/update-document-manage`;
export const CREATE_DOCUMENT_MANAGE_API = `${REGULATION_API}/create-document-manage`;
export const DELETE_DOCUMENT_MANAGE_API = `${REGULATION_API}/delete-document-manage`;

// ho so - tai lieu
export const GET_HOSO_API = `${REGULATION_API}/get-ho-so`;
export const GET_HOSO_BY_ID_API = `${REGULATION_API}/get-ho-so-by-id`;
export const UPDATE_HOSO_API = `${REGULATION_API}/update-ho-so`;
export const CREATE_HOSO_API = `${REGULATION_API}/create-ho-so`;
export const DELETE_HOSO_API = `${REGULATION_API}/delete-ho-so`;

//Bang Phu cap Giam tru
export const BANG_PHU_CAP_GIAM_TRU_API = `${PREFIX}/QuanLyPhuCapGiamTru`;
export const CHI_TIET_BANG_PHU_CAP_GIAM_TRU_API = `${BANG_PHU_CAP_GIAM_TRU_API}/chi-tiet`;

export const THIETLAPDMKSK_API = `${PREFIX}/ThietLapDmKSK`;
export const KHAMSUCKHOEDOAN_API = `${PREFIX}/DoanKhamSucKhoe`;

//Ghi Nhan Yeu Cau

export const GHI_NHAN_API = `${PREFIX}/GhiNhanYeuCau`;
export const GET_GHI_NHAN_BY_ID_API = `${GHI_NHAN_API}/get-by-id`;
export const GET_HISTORY_GHI_NHAN_BY_ID_API = `${GHI_NHAN_API}/get-history-by-id`;
export const GET_ALL_GHI_NHAN_API = `${GHI_NHAN_API}/get-all`;
export const UP_SERT_GHI_NHAN_API = `${GHI_NHAN_API}/up-sert`;
export const UPDATE_GHI_NHAN_API = `${GHI_NHAN_API}/update-ghi-nhan`;
export const GET_CATE_GHI_NHAN_API = `${GHI_NHAN_API}/get-category`;
export const EXPORT_GHI_NHAN_API = `${GHI_NHAN_API}/export-excel`;

//SALE

export const NHAPXUAT_API = `${PREFIX}/NhapXuat`;
export const NHAPKHO_API = `${PREFIX}/NhapKho`;
export const XUATKHO_API = `${PREFIX}/XuatKho`;
export const DANHMUC_API = `${PREFIX}/DanhMuc`;
export const BANHANG_API = `${PREFIX}/BanHang`;
export const TRAHANG_API = `${PREFIX}/TraHang`;
export const THUCHI_API = `${PREFIX}/ThuChi`;
export const TRACUU_API = `${PREFIX}/TraCuu`;
export const BAOCAO_API = `${PREFIX}/BaoCao`;
export const THIETLAPHETHONG_API = `${PREFIX}/ThietLapHeThong`;
export const DEXUATMUASAM_API = `${PREFIX}/DeXuatMuaSam`;
export const TONGHOPDEXUATMUASAM_API = `${PREFIX}/TongHopDeXuatMuaSam`;
export const SALECHANGEHISTORY_API = `${PREFIX}/SaleChangeHistory`;
export const KE_HOACH_MUA_HANG_API = `${PREFIX}/KeHoachMuaHang`;
export const FINANCE_MUA_BAN_HANG_API = `${PREFIX}/FinanceMuaBanHang`;
//Notifications

export const THONG_BAO_API = `/api/ErpNotification`;
export const GET_THONG_BAO_API = `${THONG_BAO_API}/get-all-noti`;
export const READALL_THONG_BAO_API = `${THONG_BAO_API}/read-all`;
export const DELETEALL_THONG_BAO_API = `${THONG_BAO_API}/delete-all`;
export const DELETEBYID_THONG_BAO_API = `${THONG_BAO_API}/delete-by-id`;
export const MARKREAD_THONG_BAO_API = `${THONG_BAO_API}/mark-read`;

// Comment
export const ERP_COMMENT_API = `/api/ErpComment`;

// EmployeeTransfer
export const EMPLOYEE_TRANSFER_API = `${PREFIX}/EmployeeTransfer`;

//Partner

export const PARTNER_API = `${PREFIX}/Partner`;
export const GET_PARTNERS_API = `${PARTNER_API}/get-partners`;
export const GET_PARTNER_BY_ID_API = `${PARTNER_API}/get-partner-by-id`;
export const UPDATE_PARTNER_API = `${PARTNER_API}/update-partner`;
export const CREATE_PARTNER_API = `${PARTNER_API}/create-partner`;
export const DELETE_PARTNER_API = `${PARTNER_API}/delete-partner`;

//HRM - Thiet lập khác

export const THIET_LAP_KHAC_API = `${PREFIX}/ThietLapKhac`;
export const GET_CHUC_VU_CATEGORY_API = `${THIET_LAP_KHAC_API}/get-chuc-vu-category`;
export const UPDATE_CHUC_VU_CATEGORY_API = `${THIET_LAP_KHAC_API}/update-chuc-vu-category`;
export const CREATE_CHUC_VU_CATEGORY_API = `${THIET_LAP_KHAC_API}/create-chuc-vu-category`;
export const DELETE_CHUC_VU_CATEGORY_API = `${THIET_LAP_KHAC_API}/delete-chuc-vu-category`;

export const GET_CHUC_DANH_CATEGORY_API = `${THIET_LAP_KHAC_API}/get-chuc-danh-category`;
export const UPDATE_CHUC_DANH_CATEGORY_API = `${THIET_LAP_KHAC_API}/update-chuc-danh-category`;
export const CREATE_CHUC_DANH_CATEGORY_API = `${THIET_LAP_KHAC_API}/create-chuc-danh-category`;
export const DELETE_CHUC_DANH_CATEGORY_API = `${THIET_LAP_KHAC_API}/delete-chuc-danh-category`;

export const GET_CHUYEN_MON_CATEGORY_API = `${THIET_LAP_KHAC_API}/get-chuyen-mon-category`;
export const UPDATE_CHUYEN_MON_CATEGORY_API = `${THIET_LAP_KHAC_API}/update-chuyen-mon-category`;
export const CREATE_CHUYEN_MON_CATEGORY_API = `${THIET_LAP_KHAC_API}/create-chuyen-mon-category`;
export const DELETE_CHUYEN_MON_CATEGORY_API = `${THIET_LAP_KHAC_API}/delete-chuyen-mon-category`;

export const GET_HOC_VAN_CATEGORY_API = `${THIET_LAP_KHAC_API}/get-hoc-van-category`;
export const UPDATE_HOC_VAN_CATEGORY_API = `${THIET_LAP_KHAC_API}/update-hoc-van-category`;
export const CREATE_HOC_VAN_CATEGORY_API = `${THIET_LAP_KHAC_API}/create-hoc-van-category`;
export const DELETE_HOC_VAN_CATEGORY_API = `${THIET_LAP_KHAC_API}/delete-hoc-van-category`;

//Tài chính kế toán

export const DINH_KHOAN_CATE_API = `${PREFIX}/DanhMucDinhKhoan`;
export const DANH_MUC_NGAM_DINH_API = `${PREFIX}/DanhMucNgamDinh`;
export const DANH_MUC_QUY_API = `${PREFIX}/DanhMucQuy`;
export const GET_TREE_DINH_KHOAN_CATE_API = `${DINH_KHOAN_CATE_API}/get-tree-cate-dinh-khoan`;
export const GET_DINH_KHOAN_CATE_API = `${DINH_KHOAN_CATE_API}/get-cate-dinh-khoan`;
export const GET_DINH_KHOAN_CATE_BY_ID_API = `${DINH_KHOAN_CATE_API}/get-cate-dinh-khoan-by-id`;
export const UPDATE_DINH_KHOAN_CATE_API = `${DINH_KHOAN_CATE_API}/update-cate-dinh-khoan`;
export const CREATE_DINH_KHOAN_CATE_API = `${DINH_KHOAN_CATE_API}/create-cate-dinh-khoan`;
export const DELETE_DINH_KHOAN_CATE_API = `${DINH_KHOAN_CATE_API}/delete-cate-dinh-khoan`;

export const DE_NGHI_CHI_API = `${PREFIX}/DeNghiChiTien`;
export const DE_NGHI_THU_TIEN_API = `${PREFIX}/DeNghiThuTien`;
export const PHIEU_CHI_API = `${PREFIX}/PhieuChiTien`;
export const PHIEU_THU_API = `${PREFIX}/PhieuThu`;
export const BAO_CAO_TAI_CHINH_API = `${PREFIX}/BaoCaoThongKe`;
export const DE_NGHI_UNG_API = `${PREFIX}/DeNghiTamUng`;
export const CHUYEN_TIEN_NOI_BO_API = `${PREFIX}/ChuyenTienNoiBo`;
export const DE_XUAT_THANHTOAN_API = `${PREFIX}/DeXuatThanhToan`;
export const CHUNG_TU_NGHIEP_VU_KHAC_API = `${PREFIX}/ChungTuNghiepVuKhac`;
export const SO_CAI_TONG_HOP_KE_TOAN_API = `${PREFIX}/SoCaiTongHopKeToan`;

export const THU_CHI_CATE_API = `${PREFIX}/DanhMucThuChi`;
export const GET_TREE_THU_CHI_CATE_API = `${THU_CHI_CATE_API}/get-tree-cate-thu-chi`;
export const GET_THU_CHI_CATE_API = `${THU_CHI_CATE_API}/get-cate-thu-chi`;
export const GET_THU_CHI_CATE_BY_ID_API = `${THU_CHI_CATE_API}/get-cate-thu-chi-by-id`;
export const UPDATE_THU_CHI_CATE_API = `${THU_CHI_CATE_API}/update-cate-thu-chi`;
export const CREATE_THU_CHI_CATE_API = `${THU_CHI_CATE_API}/create-cate-thu-chi`;
export const DELETE_THU_CHI_CATE_API = `${THU_CHI_CATE_API}/delete-cate-thu-chi`;
export const DANH_MUC_BIEU_THUE_TIEU_THU_API = `${PREFIX}/DanhMucBieuThueTieuThu`;

//Tài sản API CONSTANT

export const SETTING_TAI_SAN_API = `${PREFIX}/SettingTaiSan`;
export const GET_NHOM_TAI_SAN_API = `${SETTING_TAI_SAN_API}/get-nhom-tai-san`;
export const GET_NHOM_TAI_SAN_BY_ID_API = `${SETTING_TAI_SAN_API}/get-nhom-tai-san-by-id`;
export const UPDATE_NHOM_TAI_SAN_API = `${SETTING_TAI_SAN_API}/update-nhom-tai-san`;
export const CREATE_NHOM_TAI_SAN_API = `${SETTING_TAI_SAN_API}/create-nhom-tai-san`;
export const DELETE_NHOM_TAI_SAN_API = `${SETTING_TAI_SAN_API}/delete-nhom-tai-san`;

export const GET_LOAI_TAI_SAN_API = `${SETTING_TAI_SAN_API}/get-loai-tai-san`;
export const GET_LOAI_TAI_SAN_BY_ID_API = `${SETTING_TAI_SAN_API}/get-loai-tai-san-by-id`;
export const UPDATE_LOAI_TAI_SAN_API = `${SETTING_TAI_SAN_API}/update-loai-tai-san`;
export const CREATE_LOAI_TAI_SAN_API = `${SETTING_TAI_SAN_API}/create-loai-tai-san`;
export const DELETE_LOAI_TAI_SAN_API = `${SETTING_TAI_SAN_API}/delete-loai-tai-san`;

export const TAI_SAN_API = `${PREFIX}/TaiSan`;
export const GET_TAI_SAN_API = `${TAI_SAN_API}/search`;
export const EXPORT_TAI_SAN_API = `${TAI_SAN_API}/export-excel`;
export const IMPORT_TAI_SAN_API = `${TAI_SAN_API}/import-excel`;
export const GET_TAI_SAN_BY_ID_API = `${TAI_SAN_API}/get-tai-san-by-id`;
export const GET_TAI_SAN_CO_THE_CAP_PHAT = `${TAI_SAN_API}/get-tai-san-co-the-cap-phat-by-ids`;
export const UPDATE_TAI_SAN_API = `${TAI_SAN_API}/update-tai-san`;
export const CREATE_TAI_SAN_API = `${TAI_SAN_API}/create-tai-san`;
export const DELETE_TAI_SAN_API = `${TAI_SAN_API}/delete-tai-san`;
export const PUBLICVIEW_API = `${PREFIX}/PublicView`;

export const THU_HOI_TS_API = `${PREFIX}/ThuHoi`;
export const GET_TTTH_BY_TSID = `${THU_HOI_TS_API}/get-ttth-by-tsid`;
export const THU_HOI_TAI_SAN_API = `${THU_HOI_TS_API}/thu-hoi-tai-san`;
export const GET_THU_HOI_BY_ID_API = `${THU_HOI_TS_API}/get-thu-hoi-by-id`;

export const SUA_CHUA_API = `${PREFIX}/SuaChua`;
export const Bao_Mat_API = `${PREFIX}/BaoMat`;
export const CAP_PHAT_TAI_SAN_API = `${TAI_SAN_API}/cap-phat-tai-san`;
export const GET_CAP_PHAT_BY_ID_API = `${TAI_SAN_API}/get-cap-phat-by-id`;
export const GET_QUA_TRINH_SU_DUNG_API = `${TAI_SAN_API}/get-qua-trinh-su-dung`;
export const ASSET_DIEU_CHUYEN_API = `${PREFIX}/AssetDieuChuyen`;
export const VI_TRI_TAI_SAN_API = `${PREFIX}/ViTriTaiSan`;
export const DE_XUAT_MUA_SAM_API = `${PREFIX}/DeXuatMuaSam`;
export const BAN_GIAO_TAI_SAN_API = `${PREFIX}/BanGiaoTaiSan`;
export const LINH_KIEN_API = `${PREFIX}/LinhKien`;

export const KIEM_KE_API = `${PREFIX}/KiemKe`;
export const NHA_CUNG_CAP_API = `${PREFIX}/DmNhaCungCap`;

export const BAO_DUONG_API = `${PREFIX}/BaoDuong`;

export const DMXUAT_XU_API = `${PREFIX}/DmXuatXu`;
export const NHA_SAN_XUAT_API = `${PREFIX}/NhaSanXuat`;
export const HUY_TAI_SAN_API = `${PREFIX}/HuyTaiSan`;
export const DE_NGHI_THANH_LY_API = `${PREFIX}/DeNghiThanhLy`;
export const QUA_TRINH_SU_DUNG_API = `${PREFIX}/QuaTrinhSuDung`;

export const DIEU_XE_API = `${PREFIX}/DieuXe`;
export const PHIEU_TANG_GIAM_NHAN_SU_API = `${PREFIX}/PhieuTangGiamNhanSu`;

export const CHAT_API = `/api/chat`

const THIET_LAP_NOI_BO_API = `${PREFIX}/ThietLapNoiBo`;
export const GET_THEME_SINH_NHAT = `${THIET_LAP_NOI_BO_API}/get-theme-sinh-nhat`
export const CREATE_THEME_SINH_NHAT = `${THIET_LAP_NOI_BO_API}/create-theme-sinh-nhat`
export const UPDATE_THEME_SINH_NHAT = `${THIET_LAP_NOI_BO_API}/update-theme-sinh-nhat`
export const DELETE_THEME_SINH_NHAT = `${THIET_LAP_NOI_BO_API}/delete-theme-sinh-nhat`

const MARKETING_NOI_BO_API = `${PREFIX}/MarketingNoiBo`;
export const GET_ALL_MARKETING_NOI_BO = `${MARKETING_NOI_BO_API}/get-all`;
export const UPSERT_MARKETING_NOI_BO = `${MARKETING_NOI_BO_API}/upsert`;
export const DELETE_MARKETING_NOI_BO = `${MARKETING_NOI_BO_API}/delete`;
export const GUI_THONG_BAO_MARKETING_NOI_BO = `${MARKETING_NOI_BO_API}/gui-thong-bao`;
export const GET_ACTIVE_MARKETING_NOI_BO = `${MARKETING_NOI_BO_API}/get-active-for-user`;
export const GHI_LOG_MARKETING_NOI_BO = `${MARKETING_NOI_BO_API}/ghi-log`;


